module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 footer-social-icons"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": _vm.contact.email_link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "social-icon",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.email_icon_light,
      "type": "image/svg+xml"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contact.instagram_link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "social-icon social-icon-insta",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.instagram_icon_light,
      "type": "image/svg+xml"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contact.phone_link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "social-icon",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.phone_icon_light,
      "type": "image/svg+xml"
    }
  })])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-7"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "static/img/common/logo.svg",
      "type": "image/svg+xml"
    }
  }), _vm._v(" "), _c('label', [_c('strong', [_vm._v("CREATIVE FOOD INDULGENCE")]), _c('br'), _vm._v("©Room Service 2020")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c3f74b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footbar.vue
// module id = 138
// module chunks = 2